export default __webpack_public_path__ + "static/media/ProjectsMain.15a1edad.png";